import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../../ProAdmin.css';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default function ProAdmin() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    
    // Calendly state
    const [calendlyLink, setCalendlyLink] = useState('');
    const [savedLink, setSavedLink] = useState('');
    const [calendlyMessage, setCalendlyMessage] = useState('');
    
    // Phone numbers state
    const [id, setId] = useState('');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [salesHotline, setSalesHotline] = useState('');
    const [landline, setLandline] = useState('');
    const [tollFree, setTollFree] = useState('');
    const [phoneMessage, setPhoneMessage] = useState('');

    const API_PATH = `${SERVER_URL}contact_numbers.php`;
    useEffect(() => {
        if (!isLoggedIn) return;

        fetch(API_PATH)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const numbers = data.contact_numbers;

            setId(numbers.id);
            setWhatsappNumber(numbers.whatsapp_number);
            setSalesHotline(numbers.sales_hotline);
            setLandline(numbers.landline);
            setTollFree(numbers.toll_free_number);
            // console.log('Contact numbers fetched:', data);
        })
        .catch(error => {
            console.error('Error fetching contact numbers:', error);

            setWhatsappNumber(process.env.REACT_APP_WHATSAPP_NUMBER || '971552689069');
            setSalesHotline(process.env.REACT_APP_SALES_HOTLINE || '971557539410');
            setLandline(process.env.REACT_APP_LANDLINE || '97142555563');
            setTollFree(process.env.REACT_APP_TOLL_FREE || '600503327');
        });

    }, [isLoggedIn]);

    // Check if already logged in and load saved values
    useEffect(() => {
        const adminSession = sessionStorage.getItem('proadmin_session');
        if (adminSession === 'authenticated') {
            setIsLoggedIn(true);
        }
        
        // Load saved values from localStorage or use defaults from env
        const storedLink = localStorage.getItem('calendly_link') || process.env.REACT_APP_CALENDLY_LINK || 'https://calendly.com/abdulrahman-timexpress/30min';
        setCalendlyLink(storedLink);
        setSavedLink(storedLink);
        
        // Load phone numbers
        // setWhatsappNumber(localStorage.getItem('whatsapp_number') || process.env.REACT_APP_WHATSAPP_NUMBER || '971552689069');
        // setSalesHotline(localStorage.getItem('sales_hotline') || process.env.REACT_APP_SALES_HOTLINE || '97142996888');
        // setLandline(localStorage.getItem('landline') || process.env.REACT_APP_LANDLINE || '97142555463');
        // setTollFree(localStorage.getItem('toll_free') || process.env.REACT_APP_TOLL_FREE || '600503327');

    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        setLoginError('');

        const envUsername = process.env.REACT_APP_ADMIN_USERNAME || 'relian';
        const envPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'relianistheog';

        if (username === envUsername && password === envPassword) {
            setIsLoggedIn(true);
            sessionStorage.setItem('proadmin_session', 'authenticated');
        } else {
            setLoginError('Invalid username or password');
        }
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        sessionStorage.removeItem('proadmin_session');
        setUsername('');
        setPassword('');
    };

    const handleSaveCalendlyLink = (e) => {
        e.preventDefault();
        if (calendlyLink.trim()) {
            localStorage.setItem('calendly_link', calendlyLink.trim());
            setSavedLink(calendlyLink.trim());
            setCalendlyMessage('Calendly link updated successfully!');
            setTimeout(() => setCalendlyMessage(''), 3000);
        }
    };

    // const handleSavePhoneNumbers = (e) => {
    const handleSavePhoneNumbers = async  (e) => {
        e.preventDefault();
        // localStorage.setItem('whatsapp_number', whatsappNumber.trim());
        // localStorage.setItem('sales_hotline', salesHotline.trim());
        // localStorage.setItem('landline', landline.trim());
        // localStorage.setItem('toll_free', tollFree.trim());
        // setPhoneMessage('Phone numbers updated successfully!');
        // setTimeout(() => setPhoneMessage(''), 3000);

        const payload = {
            id: id,
            whatsapp_number: whatsappNumber,
            sales_hotline: salesHotline,
            landline: landline,
            toll_free_number: tollFree
        };

        // console.log('Submitting contact numbers:', payload);

        try {
            const response = await fetch(`${SERVER_URL}update_contact_numbers.php`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            if (data.status === "success") {
                // alert("Contact numbers updated successfully!");
                setPhoneMessage('Phone numbers updated successfully!');
                console.log("Update success:", data);
            } else {
                throw new Error(data.message || "Update failed");
            }

            setTimeout(() => {
                setPhoneMessage('');
            }, 3000);

        } catch (error) {
            console.error("Error submitting contact numbers:", error);
            alert("Something went wrong while updating contact numbers.");
        }
    };

    // Format phone number for display
    const formatPhone = (num) => {
        if (!num) return '';
        const cleaned = num.replace(/\D/g, '');
        if (cleaned.startsWith('971')) {
            return `+${cleaned.slice(0, 3)} ${cleaned.slice(3, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
        }
        if (cleaned.startsWith('600')) {
            return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
        }
        return cleaned;
    };

    // Login Form
    if (!isLoggedIn) {
        return (
            <div className="proadmin-page">
                <Helmet>
                    <title>Pro Admin | Time Express</title>
                </Helmet>
                <div className="proadmin-login-container">
                    <div className="proadmin-login-box">
                        <div className="proadmin-logo">
                            <h1>Pro Admin</h1>
                            <p>Time Express Settings</p>
                        </div>
                        <form onSubmit={handleLogin} className="proadmin-login-form">
                            <div className="proadmin-input-group">
                                <label htmlFor="username">Username</label>
                                <input
                                    type="text"
                                    id="username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Enter username"
                                    required
                                />
                            </div>
                            <div className="proadmin-input-group">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter password"
                                    required
                                />
                            </div>
                            {loginError && <div className="proadmin-error">{loginError}</div>}
                            <button type="submit" className="proadmin-login-btn">
                                Login
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    // Admin Dashboard 
    return (
        <div className="proadmin-page">
            <Helmet>
                <title>Pro Admin Dashboard | Time Express</title>
            </Helmet>
            <div className="proadmin-dashboard">
                <header className="proadmin-header">
                    <h1>Pro Admin Dashboard</h1>
                    <button onClick={handleLogout} className="proadmin-logout-btn">
                        Logout
                    </button>
                </header>

                <div className="proadmin-content">
                    {/* Calendly Card */}
                    <div className="proadmin-card">
                        <h2>📅 Calendly Integration</h2>
                        <p className="proadmin-description">
                            Update the Calendly scheduling link used on the Contact Sales page.
                        </p>
                        
                        <div className="proadmin-current-link">
                            <strong>Current Link:</strong>
                            <a href={savedLink} target="_blank" rel="noopener noreferrer">
                                {savedLink}
                            </a>
                        </div>

                        <form onSubmit={handleSaveCalendlyLink} className="proadmin-form">
                            <div className="proadmin-input-group">
                                <label htmlFor="calendlyLink">New Calendly Link</label>
                                <input
                                    type="url"
                                    id="calendlyLink"
                                    value={calendlyLink}
                                    onChange={(e) => setCalendlyLink(e.target.value)}
                                    placeholder="https://calendly.com/your-link"
                                    required
                                />
                            </div>
                            <button type="submit" className="proadmin-save-btn">
                                Update Calendly Link
                            </button>
                            {calendlyMessage && <div className="proadmin-success">{calendlyMessage}</div>}
                        </form>
                    </div>

                    {/* Phone Numbers Card */}
                    <div className="proadmin-card">
                        <h2>📞 Contact Numbers</h2>
                        <p className="proadmin-description">
                            Update the phone numbers displayed on the website (Home, Contact Sales, Footer).
                        </p>

                        <form onSubmit={handleSavePhoneNumbers} className="proadmin-form">
                            <div className="proadmin-input-group">
                                <label htmlFor="whatsappNumber">WhatsApp Number</label>
                                <input
                                    type="tel"
                                    id="whatsappNumber"
                                    value={whatsappNumber}
                                    onChange={(e) => setWhatsappNumber(e.target.value)}
                                    placeholder="971552689069"
                                />
                                <span className="proadmin-hint">Display: {formatPhone(whatsappNumber)}</span>
                            </div>
                            
                            <div className="proadmin-input-group">
                                <label htmlFor="salesHotline">Sales Hotline</label>
                                <input
                                    type="tel"
                                    id="salesHotline"
                                    value={salesHotline}
                                    onChange={(e) => setSalesHotline(e.target.value)}
                                    placeholder="97142996888"
                                />
                                <span className="proadmin-hint">Display: {formatPhone(salesHotline)}</span>
                            </div>
                            
                            <div className="proadmin-input-group">
                                <label htmlFor="landline">Landline</label>
                                <input
                                    type="tel"
                                    id="landline"
                                    value={landline}
                                    onChange={(e) => setLandline(e.target.value)}
                                    placeholder="97142555463"
                                />
                                <span className="proadmin-hint">Display: {formatPhone(landline)}</span>
                            </div>
                            
                            <div className="proadmin-input-group">
                                <label htmlFor="tollFree">Toll-Free Number</label>
                                <input
                                    type="tel"
                                    id="tollFree"
                                    value={tollFree}
                                    onChange={(e) => setTollFree(e.target.value)}
                                    placeholder="600503327"
                                />
                                <span className="proadmin-hint">Display: {formatPhone(tollFree)}</span>
                            </div>
                            
                            <button type="submit" className="proadmin-save-btn">
                                Update Phone Numbers
                            </button>
                            {phoneMessage && <div className="proadmin-success">{phoneMessage}</div>}
                        </form>
                    </div>
                </div>

                {/* Preview Section */}
                <div className="proadmin-preview-section">
                    <h2>Calendly Preview</h2>
                    <div className="proadmin-calendly-preview">
                        <iframe
                            src={savedLink}
                            width="100%"
                            height="500"
                            frameBorder="0"
                            title="Calendly Preview"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}
